import React from 'react';
import {SurveyProvider} from "../../context/SurveyContext";
import Survey from './Survey';
import { useLingui, Trans } from '@lingui/react/macro';

function ImmigrationCheck() {
    const {t} = useLingui();

    const PreSurveySection = () => (
        <div className="mt-4 leading-normal text-lg text-grey-darker">
            <Trans id="immigration_check_pre_info_text">
                <p><b>Mandatory Entry Requirement - Barbados Online Immigration and Customs Form</b></p>
                <p>All travellers are required to complete the online Immigration and Customs Form, once within 72 hours prior to your arrival into Barbados.</p>
                <p>To complete the online check-in process for your cruise, you must confirm that all guests listed on your booking have completed this mandatory entry requirement.</p>
            </Trans>
        </div>
    );

    const PostSurveySection = () => (
        <div className="mt-4 leading-normal text-lg text-grey-darker">
            <Trans id="immigration_check_post_info_text">
                <p>
                    If you are yet to do so, please follow this link to complete your application: {" "}
                    <a className="text-primary-dark"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.travelform.gov.bb/"
                    > 
                        Barbados - Online Immigration & Customs Portal
                    </a>
                </p>
            </Trans>
        </div>
    );

    return (
        <SurveyProvider>
            <Survey
                title={t({id: "immigration_check"})}
                preSurveySection={<PreSurveySection />}
                postSurveySection={<PostSurveySection/>}
                category="preflightInfo"
                reponseKeyName="immigration"
            />
        </SurveyProvider>
    );
}


export default ImmigrationCheck;